import React, { Component } from "react"
import { FaAngleRight } from "react-icons/fa"

export default class GettingStarted extends Component {
  render() {
    return (
      <>
        <section id="getting-started" class="getting-started lg:px-0 px-8">
          <div class="container mx-auto">
            <div class="getting-started-inner">
              <div class="getting-started-inner_header">
                <h1>
                  <span>Getting&nbsp;</span>
                  <span>Started&nbsp;</span>is
                  <span>&nbsp;easy</span>
                </h1>
                <p>
                  Avail offers up to <b>90% OFF</b> on various categories
                </p>
              </div>
            </div>

            <div id="steps" class="steps flex-wrap">
              <div class="step lg:w-1/7 w-full lg:flex-1 flex-none">
                <div class="steps___circle">
                  <span>1</span>
                </div>
                <h4>Get your card</h4>
                <p>
                  Order your card and <br />
                  we will get it delivered
                  <br /> to you
                </p>
              </div>
              <div className="hidden lg:block w-1/7">
                <FaAngleRight />
              </div>
              <div class="step lg:w-1/7 w-full lg:flex-1 flex-none">
                <div class="steps___circle">
                  <span>2</span>
                </div>
                <h4>Download App</h4>
                <p>
                  Download the app & get
                  <br /> instant access to amazing
                  <br /> deals
                </p>
              </div>
              <div className="hidden lg:block w-1/7">
                <FaAngleRight />
              </div>

              <div class="step lg:w-1/7 w-full lg:flex-1 flex-none">
                <div class="steps___circle">
                  <span>3</span>
                </div>
                <h4>Avail great Offers</h4>
                <p>
                  Visit your favorite outlets
                  <br /> and avail amazing offers
                  <br /> with a click
                </p>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}
